// useResponsiveLayout — хук для определения viewport и переключения NavRail/SideDrawer.
// Mobile (<600px): SideDrawer. Desktop (≥600px): NavRail.
import { useMediaQuery, useTheme } from '@mui/material';

export interface ResponsiveLayout {
  isMobile: boolean;
  isDesktop: boolean;
  isTablet: boolean;
}

/** Хук для определения layout по текущему breakpoint. */
export function useResponsiveLayout(): ResponsiveLayout {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // <600px
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600-900px
  const isDesktop = useMediaQuery(theme.breakpoints.up('md')); // ≥900px
  return { isMobile, isTablet, isDesktop };
}
